import * as React from 'react';
import { Icon, UtilityText, styled } from '@leagueplatform/genesis-core';
import { FolderIconSvg } from '@web-config-app/core-react-ui';
import type { ParentId } from '@web-config-app/core';

const StyledNavButton = styled('button', {
  alignItems: 'center',
  background: 'none',
  border: 'none',
  color: '$onSurfaceTextPrimary',
  cursor: 'pointer',
  display: 'flex',
  justifyItems: 'flex-start',
  padding: '$half 0',
  textAlign: 'left',
  width: '100%',
  '&:hover, &:focus': {
    '> span, > svg': {
      color: '$interactiveActionHovered',
    },
  },
});

export type PassIdFunction = (id: ParentId) => void;

export interface DataPointCategoryItemProps {
  id: ParentId;
  label: string;
  onNavigate: PassIdFunction;
}

/**
 * Renders a navigable category item that represents a folder/group of data points.
 * Displays a folder icon, label, and chevron to indicate it can be navigated into.
 */
export const DataPointCategoryItem: React.FC<DataPointCategoryItemProps> = ({
  id,
  label,
  onNavigate,
}) => (
  <StyledNavButton type="button" onClick={() => onNavigate(id)}>
    <Icon
      css={{
        display: 'flex',
        marginInlineEnd: '$half',
        color: '$onSurfaceIconPrimary',
      }}
      size="$one"
      icon={<FolderIconSvg />}
    />
    <UtilityText>{label}</UtilityText>
    <Icon
      css={{ marginInlineStart: 'auto', color: '$onSurfaceIconPrimary' }}
      icon="interfaceChevronRight"
    />
  </StyledNavButton>
);
